/**
 * Alert types matching firmware enum (main.cpp:158-166)
 * Values must match uint8_t encoding in BLE packets
 */
export enum AlertType {
  NONE = 0,
  NEW_AP = 1,
  DEAUTH = 2,
  NEW_BLE = 3,
  SPIKE_24GHZ = 4,
  SPIKE_SUBGHZ = 5,
  JAMMER = 6,
}

export type AlertSeverity = 'critical' | 'high' | 'medium' | 'low';

export const ALERT_SEVERITY: Record<AlertType, AlertSeverity> = {
  [AlertType.NONE]: 'low',
  [AlertType.NEW_AP]: 'high',
  [AlertType.DEAUTH]: 'critical',
  [AlertType.NEW_BLE]: 'low',
  [AlertType.SPIKE_24GHZ]: 'medium',
  [AlertType.SPIKE_SUBGHZ]: 'medium',
  [AlertType.JAMMER]: 'critical',
};

export const ALERT_LABELS: Record<AlertType, string> = {
  [AlertType.NONE]: 'None',
  [AlertType.NEW_AP]: 'New WiFi AP',
  [AlertType.DEAUTH]: 'Deauth Flood',
  [AlertType.NEW_BLE]: 'New BLE Devices',
  [AlertType.SPIKE_24GHZ]: '2.4 GHz Spike',
  [AlertType.SPIKE_SUBGHZ]: 'Sub-GHz Spike',
  [AlertType.JAMMER]: 'Jammer Detected',
};

export const ALERT_DESCRIPTIONS: Record<AlertType, string> = {
  [AlertType.NONE]: '',
  [AlertType.NEW_AP]: 'A new WiFi access point appeared that was not in the baseline. Possible rogue AP or evil twin attack.',
  [AlertType.DEAUTH]: 'High rate of deauthentication frames detected. Possible WiFi denial-of-service attack.',
  [AlertType.NEW_BLE]: 'Multiple new BLE devices appeared simultaneously. Possible BLE scanning or tracking activity.',
  [AlertType.SPIKE_24GHZ]: 'Power levels in the 2.4 GHz band exceeded 3-sigma above baseline on multiple channels.',
  [AlertType.SPIKE_SUBGHZ]: 'Sub-GHz power anomaly detected. Possible replay attack or unauthorized RF transmission.',
  [AlertType.JAMMER]: 'Broadband power increase across 2.4 GHz spectrum. Possible RF jamming attack.',
};

export interface Alert {
  id?: number;
  type: AlertType;
  severity: AlertSeverity;
  wifiApCount: number;
  bleDeviceCount: number;
  strongestRssi: number;
  uptimeMs: number;
  receivedAt: number;
}
